import styled from "styled-components";

export const NavigationWrapper = styled.nav`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 19px 40px;
    border-bottom: 1px solid var(--color-border);
    position: sticky;
    top: 0;
    z-index: 50;
    background: var(--color-secondary);

    > .user-title {
        display: flex;
        column-gap: 20px;
        flex-direction: row;
        align-items: center;

        .hamburger {
            line-height: 0;
            cursor: pointer;
        }

        div:not(.hamburger) {
            display: flex;
            flex-direction: column;
            row-gap: 8px;

            .greetings {
                font-weight: 600;
                font-size: var(--step-1);
                line-height: 20px;
                color: var(--color-text-dark);
            }

            .intro {
                color: var(--color-text-dark);
                font-size: var(--step--1);
            }

            .intro.short {
                display: none;
            }
        }
    }

    > div:last-child {
        display: flex;
        flex-direction: row;
        -webkit-flex-direction: row;
        -ms-flex-direction: row;
        flex-wrap: nowrap;
        column-gap: 11px;
        [data-theme="dark"] & .rb-icon{
            background-color: var(--color-secondary)!important;
        }
        .rd-icon {
            border: 1px solid var(--color-border)!important;
            padding: 8px;
            border-radius: 100%;
            margin: auto;
        }

        .rd-icon.display-tablet {
            display: none;
        }

        div:last-child {
            display: flex;
            flex-direction: row;
            align-items: center;
            flex-wrap: nowrap;

            img {
                border-radius: 50%;
                width: 40px;
                height: 40px;
            }

            span {
                color: var(--color-text-light);
                font-weight: 600;
                font-size: calc(var(--step-0) * 0.9);
            }
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.down("md")} {
        border-color: transparent;
        padding: 1rem 1.5rem;
        position: fixed;

        &:not(.in-home) {
            justify-content: center;

            > .nav-icons {
                display: none;
            }
        }

        .user-title {
            .hamburger {
                display: none;
            }
        }

        div:not(.hamburger) {
            font-family: Inter, sans-serif;

            .greetings {
                .greeting {
                    color: var(--color-border);
                }

                .grotesk-fnt {
                    font-size: var(--step-0);
                }
            }

            .intro {
                font-size: 13px !important;
            }
        }

        > div:last-child {
            .rd-icon {
                border-radius: 12px;
                svg {
                    font-size: 24px;
                }
            }

            .rd-icon.display-tablet {
                display: flex;
            }

            .rd-icon.display-laptop {
                display: none;
            }

            > div:last-child {
                display: none;
            }
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.down("sm")} {

        div:not(.hamburger) {
            .intro:not(.short) {
                display: none;
            }

            .intro.short {
                display: block !important;
                color: #667185;
            }
        }
    }
`